module.exports = __webpack_public_path__ + "img/img-2.9b4279d9.svg";